const Storage = require('utils/storage');
const AuthSso = require('services/auth-management/sso');
const RoutingTable = require('services/auth-management/routing-table');
const AuthPersistence = require('services/auth-management/persistence');
const AuthConstants = require('services/auth-management/constants');

const LOGIN_CONTEXT_FIELDS = [
    'email',
    'schoolId',
    'roleId',
    'verificationToken',
    'sso',
    'mfaToken',
    'mfaMethod',
    'mfaPurpose',
    'mfaNeedsPhone',
    'mfaPhone',
    'mfaPhoneCountry',
    'mfaCooldownCode',
    'mfaCooldownUntil',
    'maskedDestination',
    'authMethod',
    'authStatus',
    'authFlowSource',
    'userIntent',
    'latestUserIntent',
    'lastLoginEmail',
    'forceSSOLoginPromptEmail',
    'skipSSOLoginPromptEmail',
    'redirect',
    'redirectTarget',
    'policy'
];

module.exports = {
    getLoginContext,
    getLoginContextWithQueryParams
};

function getLoginContext() {

    AuthPersistence.migrateAuthPersistence();

    const loginContext = internals.pickLoginContextFields(
        Storage.get(AuthConstants.loginContext.storageKey) || {},
        AuthConstants.loginContext.persistedFields
    );
    const mfaContext = AuthPersistence.getPersistedLoginMfaContext();

    return internals.pickLoginContextFields({
        ...loginContext,
        ...mfaContext
    });
}

async function getLoginContextWithQueryParams(context) {

    const redux = context.redux.hooks;
    const actions = context.actions;
    const selectors = context.selectors.all;

    const routeContext = RoutingTable.getAuthRouteContext();

    const loginContext = selectors.getLoginContext(redux.getState());

    const nextLoginContext = {
        ...loginContext,
        verificationToken: routeContext.verificationToken || loginContext.verificationToken,
        schoolId: routeContext.schoolId || loginContext.schoolId,
        roleId: routeContext.roleId || loginContext.roleId,
        email: routeContext.email || loginContext.email,
        sso: routeContext.sso || loginContext.sso,
        redirect: routeContext.redirect || loginContext.redirect,
        redirectTarget: routeContext.target || loginContext.redirectTarget
    };

    try {
        if (!nextLoginContext.schoolId && nextLoginContext.verificationToken) {
            const res = await redux.dispatch(actions.dataFetching.fetchSchoolByVerificationToken({
                token: nextLoginContext.verificationToken
            }));

            const newSchoolId = res?.payload?.result?.result?.school;
            nextLoginContext.schoolId = newSchoolId;
        }

        if (nextLoginContext.schoolId && !routeContext.sso) {
            const school = selectors.getSchoolById(
                redux.getState(),
                nextLoginContext.schoolId
            );

            nextLoginContext.sso = AuthSso.normalizeSSO(school?.sso);
        }
    }
    catch (err) {
        console.log('getLoginContextWithQueryParams err', err);
    }

    nextLoginContext.sso = AuthSso.normalizeSSO(nextLoginContext.sso);

    const authFlow = RoutingTable.resolveAuthFlow({
        currentContext: loginContext,
        email: nextLoginContext.email,
        preserveCurrentMfa: true,
        response: nextLoginContext,
        source: AuthConstants.authFlow.sources.loginRouteContext
    });

    return internals.pickLoginContextFields({
        ...nextLoginContext,
        ...RoutingTable.buildAuthFlowContextUpdate({ authFlow })
    });
}

const internals = {};

internals.pickLoginContextFields = (loginContext, fields = LOGIN_CONTEXT_FIELDS) => {

    if (!loginContext || typeof loginContext !== 'object') {
        return {};
    }

    return fields.reduce((collector, key) => {

        if (typeof loginContext[key] === 'undefined') {
            return collector;
        }

        return {
            ...collector,
            [key]: loginContext[key]
        };
    }, {});
};
